const FREE_SHIPPING_THRESHOLDS = {
  'NO': { amount: 400, currency: 'NOK' },
  'DK': { amount: 224, currency: 'DKK' },
  // Default fallback for other countries (EUR-based)
  'default': { amount: 33, currency: 'EUR' }
};

if (typeof window !== 'undefined') {
  window.FREE_SHIPPING_THRESHOLDS = FREE_SHIPPING_THRESHOLDS;
}